import { apiRequest } from '@/services/http'
import type { AdminLoginRequest, AdminLoginResponse, CurrentAdminUser } from '@/types/auth'

interface CenterAdminMenuResponse {
  menuId: string
  parentMenuId: string
  name: string
  menuCode: string | null
  type: 'DIRECTORY' | 'MENU'
  path: string | null
  component: string | null
  icon: string | null
  sortOrder: number
}

interface CenterCurrentAdminUserResponse {
  userId: string
  username: string
  displayName: string
  roles: string[]
  permissions: string[]
  menus: CenterAdminMenuResponse[]
}

export function loginAdmin(data: AdminLoginRequest) {
  return apiRequest<AdminLoginResponse>({
    method: 'POST',
    url: '/admin/center/auth/login',
    data
  })
}

export async function getCurrentAdmin(): Promise<CurrentAdminUser> {
  const user = await apiRequest<CenterCurrentAdminUserResponse>({
    method: 'GET',
    url: '/admin/center/auth/me'
  })
  return {
    id: user.userId,
    username: user.username,
    displayName: user.displayName,
    roles: user.roles,
    permissions: user.permissions,
    menus: user.menus.map(menu => ({
      id: menu.menuId,
      parentId: menu.parentMenuId,
      name: menu.name,
      menuCode: menu.menuCode,
      type: menu.type,
      path: menu.path,
      component: menu.component,
      icon: menu.icon,
      sortOrder: menu.sortOrder
    }))
  }
}

export function logoutAdmin() {
  return apiRequest<void>({
    method: 'POST',
    url: '/admin/center/auth/logout'
  })
}
